// SHIM — codice spostato in src/shared/msp/funzioni.js
export { default } from '@shared/msp/funzioni.js';
